<form
  [formGroup]="formGroup"
  [bitSubmit]="submit"
  bit-dialog
  [loading]="loading$ | async"
  dialogSize="large"
>
  <span bitDialogTitle>
    {{ "assignCollectionAccess" | vfo1I18n: "assignSharedFolderAccess" }}
    <span class="tw-text-sm tw-normal-case tw-text-muted">
      {{ numCollections }}
      {{
        (numCollections == 1 ? "collection" : "collections")
          | vfo1I18n: (numCollections == 1 ? "sharedFolder" : "sharedFolders")
      }}
    </span>
  </span>

  <div bitDialogContent>
    @if (!(loading$ | async)) {
      @let organization = organization$ | async;
      @if (organization?.useGroups) {
        <bit-access-selector
          [permissionMode]="PermissionMode.Edit"
          formControlName="access"
          [items]="accessItems$ | async"
          [columnHeader]="'groupSlashMemberColumnHeader' | i18n"
          [selectorLabelText]="'selectGroupsAndMembers' | i18n"
          [selectorHelpText]="'userPermissionOverrideHelperDesc' | i18n"
          [emptySelectionText]="'noMembersOrGroupsAdded' | i18n"
        ></bit-access-selector>
      } @else {
        <bit-access-selector
          [permissionMode]="PermissionMode.Edit"
          formControlName="access"
          [items]="accessItems$ | async"
          [columnHeader]="'memberColumnHeader' | i18n"
          [selectorLabelText]="'selectMembers' | i18n"
          [emptySelectionText]="'noMembersAdded' | i18n"
        ></bit-access-selector>
      }
    } @else {
      <bit-icon
        name="bwi-spinner"
        class="bwi-spin tw-text-muted"
        [ariaLabel]="'loading' | i18n"
      ></bit-icon>
    }
  </div>

  <ng-container bitDialogFooter>
    <button type="submit" bitButton bitFormButton buttonType="primary">
      {{ "save" | i18n }}
    </button>
    <button type="button" bitButton bitFormButton buttonType="secondary" bitDialogClose>
      {{ "cancel" | i18n }}
    </button>
  </ng-container>
</form>
